import React from 'react';
import styles from './TabBar.module.scss';
import classNames from 'classnames';

export const tabBarVariants = {
  full: 'full',
};
export const TabBarComponent = ({ tabs, activeTab, onTabClick, variant }) => {
  const handleTabClick = (tab) => {
    if (activeTab === tab) return;
    onTabClick?.(tab);
  };
  return (
    <div className={styles.tabBar}>
      {tabs?.map((tab, index) => (
        <div
          key={index}
          className={classNames(styles.tab, {
            [styles.tab_active]: activeTab === tab?.value,
            [styles.tab_full]: variant === tabBarVariants.full,
            [styles.tab_active_full]:
              variant === tabBarVariants.full && activeTab === tab?.value,
          })}
          onClick={() => handleTabClick(tab?.value)}
        >
          {tab?.label}
        </div>
      ))}
    </div>
  );
};
